import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['filename', 'progress', 'progressRow', 'historyRow']

  toggleHistory() {
    this.historyRowTarget.hidden = !this.historyRowTarget.hidden
  }

  fileSelected(event) {
    const file = event.target.files[0]
    if (!file) return

    this.filenameTarget.textContent = file.name
    this.filenameTarget.hidden = false

    this._sendXhr('POST', event.target.form.action, new FormData(event.target.form), {
      onProgress: (e) => {
        if (e.lengthComputable) this.progressTarget.value = (e.loaded / e.total) * 100
      },
      onStart: () => {
        if (this.hasProgressRowTarget) {
          this.progressTarget.value = 0
          this.progressRowTarget.hidden = false
        }
      },
      onSuccess: (html) => {
        if (this.hasProgressRowTarget) this.progressRowTarget.hidden = true
        this._replaceFrame(html)
      },
      onError: () => {
        if (this.hasProgressRowTarget) this.progressRowTarget.hidden = true
        this.filenameTarget.hidden = true
        this.filenameTarget.textContent = ''
      }
    })
  }

  deleteAttachment(event) {
    const url = event.currentTarget.dataset.deleteUrl
    if (!url) return

    const csrf = document.querySelector('meta[name="csrf-token"]')?.content
    const body = new URLSearchParams({ _method: 'delete' })

    this._sendXhr('POST', url, body, {
      headers: { 'X-CSRF-Token': csrf, 'Content-Type': 'application/x-www-form-urlencoded' },
      onSuccess: (html) => this._replaceFrame(html)
    })
  }

  _sendXhr(method, url, body, { headers = {}, onStart, onProgress, onSuccess, onError } = {}) {
    const xhr = new XMLHttpRequest()
    xhr.open(method, url)
    xhr.setRequestHeader('Accept', 'text/html, application/xhtml+xml')
    Object.entries(headers).forEach(([k, v]) => xhr.setRequestHeader(k, v))

    if (onProgress) xhr.upload.addEventListener('progress', onProgress)

    xhr.addEventListener('load', () => {
      if (xhr.status >= 200 && xhr.status < 400) {
        onSuccess?.(xhr.responseText)
      } else {
        onError?.()
      }
    })
    xhr.addEventListener('error', () => onError?.())

    onStart?.()
    xhr.send(body)
  }

  _replaceFrame(html) {
    const frame = this.element.closest('turbo-frame')
    if (!frame) return
    const doc = new DOMParser().parseFromString(html, 'text/html')
    const newFrame = doc.getElementById(frame.id)
    if (newFrame) frame.innerHTML = newFrame.innerHTML
  }
}
